import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10793db5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10793db5')) {
      api.createRecord('10793db5', component.options)
    } else {
      api.reload('10793db5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10793db5", function () {
      api.rerender('10793db5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/8-2-guide-add-wechat/index.vue"
export default component.exports